import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { UseCaseVariationEnums } from '../TopBarSlimEnums';

const DEFAULT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseJustForFunTopBarSlim.message',
    defaultMessage:
      'Make quizzes more fun with feedback based on answer accuracy.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseJustForFunTopBarSlim.ctaText',
    defaultMessage: 'Upgrade to unlock Quizzes Pro',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const COLLECT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseJustForFunTopBarSlim.messageCollect',
    defaultMessage:
      "Don't leave anyone out. Unlock access to answers from all survey-takers.",
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseJustForFunTopBarSlim.ctaTextCollect',
    defaultMessage: 'Get unlimited responses',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const ANALYZE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseJustForFunTopBarSlim.messageAnalyze',
    defaultMessage:
      'Uncover trends in survey comments with text analysis and word clouds.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseJustForFunTopBarSlim.ctaTextAnalyze',
    defaultMessage: 'See all plan options',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

export type UseCaseJustForFunTopBarSlimProps = {
  variation?: UseCaseVariationEnums | null;
};

const VariationToCopy = {
  [UseCaseVariationEnums.create]: DEFAULT_COPY,
  [UseCaseVariationEnums.collect]: COLLECT_COPY,
  [UseCaseVariationEnums.analyze]: ANALYZE_COPY,
};

export const UseCaseJustForFunTopBarSlim: React.FC<UseCaseJustForFunTopBarSlimProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  const ut_source = variation
    ? `slim_${variation}_upsell_just_for_fun`
    : 'slim_create_upsell_just_for_fun';

  return (
    <TopBarSlim
      message={t(copy.MESSAGE)}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL('/pricing/upgrade/', {
        ut_source: 'topbar',
        ut_source2: ut_source,
      })}
      ctaNewTab
    />
  );
};

export default UseCaseJustForFunTopBarSlim;
